import PageFrame from 'src/components/common/PageFrame';
import PasswordResetContent from 'src/components/account/PasswordResetPage/components/PasswordResetContent';

const ResetPageMobile = () => (
  <PageFrame>
    <PasswordResetContent />
  </PageFrame>
);

export default ResetPageMobile;
